/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeJobEntryListResponse,
  ApiEnvelopeJobEntryScanResponse,
  JobEntryGetAllJobEntriesByNameParams,
  JobEntryGetJobEntriesRangeParams,
  TriggerJobScanRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type jobEntryGetAllJobEntriesByNameResponse200 = {
  data: ApiEnvelopeJobEntryListResponse
  status: 200
}

export type jobEntryGetAllJobEntriesByNameResponseSuccess = (jobEntryGetAllJobEntriesByNameResponse200) & {
  headers: Headers;
};
;

export type jobEntryGetAllJobEntriesByNameResponse = (jobEntryGetAllJobEntriesByNameResponseSuccess)

export const getJobEntryGetAllJobEntriesByNameUrl = (params?: JobEntryGetAllJobEntriesByNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/JobEntry?${stringifiedParams}` : `/api/JobEntry`
}

export const useJobEntryGetAllJobEntriesByNameHook = (): (params?: JobEntryGetAllJobEntriesByNameParams, options?: RequestInit) => Promise<jobEntryGetAllJobEntriesByNameResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: JobEntryGetAllJobEntriesByNameParams, options?: RequestInit) => {

        return customFetcher(getJobEntryGetAllJobEntriesByNameUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type jobEntryGetAllJobEntriesResponse200 = {
  data: ApiEnvelopeJobEntryListResponse
  status: 200
}

export type jobEntryGetAllJobEntriesResponseSuccess = (jobEntryGetAllJobEntriesResponse200) & {
  headers: Headers;
};
;

export type jobEntryGetAllJobEntriesResponse = (jobEntryGetAllJobEntriesResponseSuccess)

export const getJobEntryGetAllJobEntriesUrl = () => {




  return `/api/JobEntry/All`
}

export const useJobEntryGetAllJobEntriesHook = (): ( options?: RequestInit) => Promise<jobEntryGetAllJobEntriesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getJobEntryGetAllJobEntriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type jobEntryTriggerJobScanResponse200 = {
  data: ApiEnvelopeJobEntryScanResponse
  status: 200
}

export type jobEntryTriggerJobScanResponseSuccess = (jobEntryTriggerJobScanResponse200) & {
  headers: Headers;
};
;

export type jobEntryTriggerJobScanResponse = (jobEntryTriggerJobScanResponseSuccess)

export const getJobEntryTriggerJobScanUrl = () => {




  return `/api/JobEntry/scan`
}

export const useJobEntryTriggerJobScanHook = (): (triggerJobScanRequest?: TriggerJobScanRequest, options?: RequestInit) => Promise<jobEntryTriggerJobScanResponse> => {

      const customFetcher = useSfetchMutator();
      return (triggerJobScanRequest?: TriggerJobScanRequest, options?: RequestInit) => {

        return customFetcher(getJobEntryTriggerJobScanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(triggerJobScanRequest)
  }
);
      }
  }


export type jobEntryGetJobEntriesRangeResponse200 = {
  data: ApiEnvelopeJobEntryListResponse
  status: 200
}

export type jobEntryGetJobEntriesRangeResponseSuccess = (jobEntryGetJobEntriesRangeResponse200) & {
  headers: Headers;
};
;

export type jobEntryGetJobEntriesRangeResponse = (jobEntryGetJobEntriesRangeResponseSuccess)

export const getJobEntryGetJobEntriesRangeUrl = (from: string,
    to: string,
    params?: JobEntryGetJobEntriesRangeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/JobEntry/${from}/${to}?${stringifiedParams}` : `/api/JobEntry/${from}/${to}`
}

export const useJobEntryGetJobEntriesRangeHook = (): (from: string,
    to: string,
    params?: JobEntryGetJobEntriesRangeParams, options?: RequestInit) => Promise<jobEntryGetJobEntriesRangeResponse> => {

      const customFetcher = useSfetchMutator();
      return (from: string,
    to: string,
    params?: JobEntryGetJobEntriesRangeParams, options?: RequestInit) => {

        return customFetcher(getJobEntryGetJobEntriesRangeUrl(from,to,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


